import { useCallback } from 'react';

import { useFormModal } from '~/components/Modals/FormModal';
import {
  bookingApi,
  BookingUpdateRequest,
  BookingUpdateResponse,
} from '~/screens/Support/Bookings/Bookings.api';
import { translate } from '~/utils/translation.utils';

export const useUpdateBookingModal = (bookingId: string, supportId: string) => {
  const { open: openForm, close: closeForm } = useFormModal();

  const useFormHookHandler = useCallback((id: string) => {
    console.log('GETTING FORM ', id);
    const { data: config, isLoading } = bookingApi.useGetBookingUpdateFormConfigQuery(id);
    return { data: { config }, isLoading };
  }, []);

  const onConfirm = async ({
    action,
    value,
  }: {
    action: (req: BookingUpdateRequest) => BookingUpdateResponse;
    value: BookingUpdateRequest;
  }) => {
    return await action({ ...value, id: bookingId, supportId });
  };

  return {
    open: (id: string) => {
      openForm({
        modalTitle: translate('bookings.updateBooking'),
        useFormHookHandler: () => useFormHookHandler(id),
        onConfirm,
        actionHook: bookingApi.useUpdateBookingMutation,
      });
    },
    close: () => {
      closeForm();
    },
  };
};
